import React from "react";
import {useState} from "react";
import {binary_sys,models} from './main_pages/physical_models.js';
import {VLE_theory} from "./main_pages/vletheory.js";
import {Distillation} from "./main_pages/distillation.js";
import {VLE_exp} from "./main_pages/vleexp.js";

const CN = 0, EN = 1;
const model_pic_dir = './assets/';
                  
                
function GraphicPageTitle({onClickLangFuncs,lang}) {
  const title_en = "VLE Phase Diagram of Binary System & Application in Distillation Column";
  const title_cn = "气液平衡与精馏数字化探究实验";
  const title = (lang===CN)? title_cn:title_en;
  
  return (
    <table>
    <tr class='tr1'>
      <td width='940px'> <h1b>  {title} </h1b> </td> 
      <td width='60px' align="right"><lang> <div class="highlight_shift" onClick={onClickLangFuncs[0]}>简体中文</div>
                                             <div class="highlight_shift" onClick={onClickLangFuncs[1]}>English</div></lang></td>
    </tr>
    </table>
    
  )
}

function FootNote({lang}) {

  const footnote_cn = 'Copyright © 2024 浙江大学 化学系 版权所有';
  const footnote_en = "Copyright © 2024 Department of Chemistry, Zhejiang University";

  const declare_cn = '本应用程序只能用于非盈利的教学目的';
  const declare_en = 'For non-profitable educational purpose only';

  const footnote = (lang===CN)? footnote_cn:footnote_en;
  const declare = (lang===CN)? declare_cn:declare_en;

  return (
    
    <tr>
      {declare}
      <br/>
      {footnote}
    </tr>
    

  )

}


function Body({lang}) {
  const model_list = ['Wilson','NRTL'];
  const [selectedModel, setSelectedModel] = useState('Wilson');
  const model_pic_path = './assets/'+ selectedModel + '_model.png';
  const general_model_pic_path = './assets/'+ 'general_model.png';
  const [selectedSystem, setSelectedSystem] = useState('Nhexane_Benzene');
  const applist_use = ['VLE_theory', 'VLE_exp','Distillation'];
  const [selectedApp, setSelectedApp] = useState('VLE_theory');
  const [tMin, setTMin] = useState(50);
  const [tMax, setTMax] = useState(120);
  const applist = { "VLE_theory":  {name_cn: '二元气液相图的理论计算',
                                    name_en: 'Calculate Binary VLE Phase Diagram',
                                    abbr: 'VLE_theory',
                                    content: <VLE_theory params={{selectedModel:selectedModel, selectedSystem:selectedSystem, lang:lang, tMax:tMax, tMin:tMin}}/>
},
                    "Distillation":{name_cn: "精馏塔模拟分离二元体系",
                                    name_en: "Simulation of Distillation",
                                    abbr: 'Distillation',
                                    content: <Distillation params={{selectedModel:selectedModel, selectedSystem:selectedSystem, lang:lang, tMax:tMax, tMin:tMin}}/>,
},

                    "VLE_exp":     {name_cn: "实验与理论对比",
                                    name_en: "Comparison btw Theory & Experiment",
                                    abbr: 'VLE_exp',
                                    content: <VLE_exp params={{selectedModel:selectedModel, selectedSystem:selectedSystem, lang:lang, tMax:tMax, tMin:tMin}}/>,
},
}
  
                                

  const binary_sys_list = {'Wilson':['Nhexane_Benzene', 'Ethanol_Nbutanol', 'Acetone_Water', 'Ethanol_Benzene', 'CCl4_Ethanol', 'Chexane_Ethanol', 'Water_CH2O2'],
                           'NRTL':['Ethanol_Benzene', 'CCl4_Ethanol', 'Chexane_Ethanol', 'Water_CH2O2'],
  }


  const general_model_cap = (lang===CN)? '二元气液平衡方程' : 'VLE Model of Binary System'

  const select_model_cap_cn = "请选择一个活度模型", select_model_cap_en = "Select an activity model";
  const select_model_cap = (lang===CN) ? select_model_cap_cn : select_model_cap_en;

  const select_system_cap_cn = "请选择一个二元体系", select_system_cap_en = "Select a system to explore";
  const select_system_cap = (lang===CN) ? select_system_cap_cn : select_system_cap_en;
  const TSetCap = (lang===CN) ? "设定Txy相图的温度范围" : "Set visable temperture range of T-x-y diagram"

  const onSelectModel = (e)=>{
    const newModel = e.target.value;
    if (newModel==='Wilson') setSelectedSystem('Nhexane_Benzene');
    else if (newModel==='NRTL') setSelectedSystem('Ethanol_Benzene');
    setSelectedModel(newModel);
  }

  const onSelectSystem = (e)=>{
    const newSys = e.target.value;

    setSelectedSystem(newSys);
  } 


  
  const handleSelectApp = (e) => {
    const newApp = e.target.value;
    
    setSelectedApp(newApp);

  }

  const handle_TMax_Change= (e) => {
    const newTMax = parseFloat(e.target.value);
    setTMax(newTMax);

  }

  const handle_TMin_Change= (e) => {
    const newTMin = parseFloat(e.target.value);
    setTMin(newTMin);

  }

  return (
    <table>
      <tr>  
        <table>
        <td width='200px'>

          {general_model_cap}<br/>&nbsp;&nbsp;
          <img src={general_model_pic_path} width='160px' height='100px' alt={general_model_pic_path}/><br/><br/>


          {select_model_cap}<br/>

          {
            model_list.map((m0)=>{ 
                const model_name = (lang===CN)?models[m0].name_cn:models[m0].name_en;
                const model_abbr = models[m0].abbr;
                return (
                  <div>
                    <input type="radio" name="model" value={model_abbr} 
                      checked={model_abbr===selectedModel} onClick={onSelectModel}/> {model_name}
                  </div>
            )
            })
          }

        </td>

        <td width='430px' align="center">
          <img src={model_pic_path} width='400px' height='222px' alt='Model Equations'/>

        </td>

        <td width='370px'>
          {select_system_cap} <br/>
          <tr>
            <tr align='center'> <td width='190px'></td>{(selectedModel==='Wilson') ? 

                    <div><td width='90px'><i>&Lambda;</i><sub>12</sub></td>
                         <td width='90px'><i>&Lambda;</i><sub>21</sub></td></div>
                    :
                    <div><td width='70px'><i>&tau;</i><sub>12</sub></td>
                         <td width='70px'><i>&tau;</i><sub>21</sub></td>
                         <td width='40px'><i>&alpha;</i><sub>12</sub></td></div>

                    }
            </tr>
          {
            binary_sys_list[selectedModel].map((s0)=>{ 
                const sys0 = binary_sys[selectedModel][s0];
                const system_abbr = sys0.abbr;
                const system_name = (lang===CN)?sys0.name_cn:sys0.name_en;
                const modelParams = sys0.modelParams;
                return (
                  <tr>
                    <td width='190px'><input type="radio" name="system" value={system_abbr} checked={system_abbr===selectedSystem} onClick={onSelectSystem}/>
                        {system_name} </td>
                    {(selectedModel==='Wilson') ? 
                    <div><td align='middle' width='90px'>{modelParams.Lambda_12.toFixed(3)}</td>
                         <td align='middle' width='90px'>{modelParams.Lambda_21.toFixed(3)}</td></div>
                    :
                    <div><td align='right' width='60px'>{modelParams.Tau_12.toFixed(3)}</td>
                         <td align='right' width='60px'>{modelParams.Tau_21.toFixed(3)}</td>
                         <td align='right' width='60px'>{modelParams.Alpha.toFixed(3)}</td></div>

                    }


                  </tr>
            )
            })
          }
          
      
          
          </tr>

        </td>        


        </table>
      </tr>
      

      <tr>   <table>  <td/>  <td> <br/><hr/><br/> </td> <td/></table>     </tr> 

      <tr>
        <table>
        <select class='dropdownBox1' value={selectedApp} onChange={handleSelectApp}>
          {
            applist_use.map((app0str)=>{

              const app0 = applist[app0str]
              const name = (lang===CN) ? app0.name_cn : app0.name_en;
              const abbr = app0.abbr;
              return (<option value={abbr}>{name} </option>)
            })

          }

        </select>

          &nbsp;&nbsp;{TSetCap} <i>T</i><sub>max</sub> = <input type="number" placeholder='' class='inputBox1' value={tMax} onChange={handle_TMax_Change}/>
          ,&nbsp;               <i>T</i><sub>min</sub> = <input type="number" placeholder='' class='inputBox1' value={tMin} onChange={handle_TMin_Change}/>

        </table>
      </tr>
      <tr>
      <br/>
      <table>

        {applist[selectedApp].content}

      </table>
      </tr>
      </table>
    
    )
  }

export default function VLE(){

  const [lang, setLang] = useState(CN);
  const onClickLangFuncs = [()=>{setLang(CN)}, ()=>{setLang(EN)}];


  return (
  
  <table width="1000px">
        <tr><GraphicPageTitle onClickLangFuncs={onClickLangFuncs} lang={lang}/></tr>
        <br/>
        <tr><Body lang={lang}/>       </tr>
        <br/>
        <tr><FootNote lang={lang}/></tr>
      </table>
      )
    }